import { render } from "./MentionList.vue?vue&type=template&id=0f9fc387&scoped=true"
import script from "./MentionList.vue?vue&type=script&lang=js"
export * from "./MentionList.vue?vue&type=script&lang=js"

import "./MentionList.vue?vue&type=style&index=0&id=0f9fc387&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f9fc387"]])

export default __exports__